import { render } from "./AddPlantDashboardRowColumn.vue?vue&type=template&id=63ae7d31"
import script from "./AddPlantDashboardRowColumn.vue?vue&type=script&lang=js"
export * from "./AddPlantDashboardRowColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__